import ApiService from '@apis/api-service'
import { API_PATHS } from '@constants/paths'

const addLead = ({ email }) =>
  ApiService.post(API_PATHS.leads.create, { email }).then((response) => response.data)

export default { addLead }
